// import imageSlider from '../../_organisms/imageSlider/_script';

/**
 * faqList
 */

const faqList = {
    cfg:  {
        name: 'faqList',
        triggers: [...document.querySelectorAll('.js-faqTrigger')],
        status: 'is-open'
    },

    // Toggle Content
    toggleAccordeon(event) {
        event.preventDefault();
        const target = event.currentTarget;
        const tabContent = document.getElementById(target.dataset.tab); // target.nextElementSibling;
        const allTabs = document.querySelectorAll('.js-faqContent');

        if (!target.classList.contains(this.cfg.status)) {
            allTabs.forEach((tab) => {
                tab.classList.remove(this.cfg.status);
            });
            this.cfg.triggers.forEach((trigger) => {
                trigger.classList.remove(this.cfg.status);
            });
            target.classList.add(this.cfg.status);
            tabContent.classList.add(this.cfg.status);

            // imageSlider.refreshSlider();
        } else {
            allTabs.forEach((tab) => {
                tab.classList.remove(this.cfg.status);
            });
            this.cfg.triggers.forEach((trigger) => {
                trigger.classList.remove(this.cfg.status);
            });
        }
    },

    init() {
        this.cfg.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                this.toggleAccordeon(event);
            });
        });
    }
};

export default faqList;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/faqList/_script.js